import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { TopbarMenuService } from './app.topbarmenu.service';
import { AppMainComponent } from '../app.main.component';
import { AppComponent } from '../app.component';

@Component({
	/* eslint-disable @angular-eslint/component-selector */
	selector: '[app-topmenu]',
	templateUrl: './app.topbarmenu.component.html',
	// eslint-disable-next-line @angular-eslint/no-host-metadata-property
	host: {
		'[class.topbar-active-menuitem]': '(active)',
	},
	animations: [
		trigger('children', [
			state(
				'void',
				style({
					height: '0px',
				}),
			),
			state(
				'hiddenAnimated',
				style({
					height: '0px',
				}),
			),
			state(
				'visibleAnimated',
				style({
					height: '*',
				}),
			),
			transition('visibleAnimated => hiddenAnimated', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)')),
			transition('hiddenAnimated => visibleAnimated', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)')),
			transition(
				'void => visibleAnimated, visibleAnimated => void',
				animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'),
			),
		]),
	],
})
export class AppTopbarMenuComponent implements OnInit {
	@Input() item: { disabled?: boolean; isActive: boolean; routerLink: string[] };

	@Input() index: number;

	@Input() root: boolean;

	@Input() parentKey: string;

	active = false;

	menuSourceSubscription: Subscription;

	menuResetSubscription: Subscription;

	key: string;

	constructor(
		public appMain: AppMainComponent,
		public app: AppComponent,
		public router: Router,
		private cd: ChangeDetectorRef,
		private topbarmenuService: TopbarMenuService,
	) {
		this.menuSourceSubscription = this.topbarmenuService.menuSource$.subscribe((key) => {
			// deactivate current active menu
			if (this.active && this.key !== key && key.indexOf(this.key) !== 0) {
				this.active = false;
			}
		});

		this.menuResetSubscription = this.topbarmenuService.resetSource$.subscribe(() => {
			this.active = false;
		});

		this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
			if (this.item.routerLink) {
				this.updateActiveStateFromRoute();
			} else {
				this.active = false;
			}
		});
	}

	ngOnInit() {
		if (this.item.routerLink) {
			this.updateActiveStateFromRoute();
		}

		this.key = this.parentKey ? this.parentKey + '-' + this.index : String(this.index);
	}

	updateActiveStateFromRoute() {
		this.active = this.router.isActive(this.item.routerLink[0], {
			paths: 'exact',
			queryParams: 'exact',
			fragment: 'ignored',
			matrixParams: 'ignored',
		});
	}

	itemClick(event: Event) {
		// avoid processing disabled items
		if (this.item.disabled) {
			event.preventDefault();
			return;
		}

		this.topbarmenuService.onMenuStateChange(this.key);
	}
}
